import React, { Component } from "react";
import MaterialTable from "material-table";
import UiUtils from "../../../provider/UiUtils";
import { withRouter } from "../../../withRouter";
import FetchServerData from "../../../provider/FetchServerData";
import { Card, CardBody } from "reactstrap";
import { MenuWithBreadScrum } from "../../menu/MenuWithBreadScrum";
import store from "../../../redux/store";
import PrintRoundedIcon from "@material-ui/icons/PrintRounded";
import ReactToPrint from "react-to-print";
import Button from "@material-ui/core/Button";
import Utils from "../../../provider/Utils";
import BackIconButton from "../../buttons/BackIconButton";

class HoldingPeriodOverCycleList extends Component {
  header = store.getState().header.header;
  breadCrumb = [
    { pageid: "/reports", uiname: "MIS Reports" },
    { pageid: "/assetCycleAnalytics", uiname: "Asset Cycle Analytics" },
    { pageid: "", uiname: "Holding Period Over Cycle List" },
  ];

  constructor() {
    super();
    this.state = {
      initialPage: 0,
      pageSize: 10,
      holdingPeriodOverCycleList: [],
      isPaging: false,
      render: false,
    };
    this.getHoldingPeriodOverCycleList();
  }
  getHoldingPeriodOverCycleList() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(
      "/misms/holdingPeriodOverCycleList",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let holdingPeriodOverCycleList = output.data.assetCycleList;
        let isPaging = false;
        if (holdingPeriodOverCycleList.length > this.state.pageSize) {
          isPaging = true;
        }
        this.setState({
          render: true,
          isPaging: isPaging,
          holdingPeriodOverCycleList: holdingPeriodOverCycleList,
          initialPage: this.state.initialPage,
        });
      } 
    });
  }

  backButton() {
    this.props.navigate("/assetCycleAnalytics");
  }
  render() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <MenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            navigate={this.props.navigate}
            domainObject="Holding Period Over"
            // name="Holding Period Over Cycle List"
          />
          {this.state.holdingPeriodOverCycleList.length > 0 ? (
            <>
              <div className="row pe-2">
                <div className="col-md-6 text-start p-2">
                  <BackIconButton onClick={this.backButton.bind(this)} />
                </div>
                <div className="col-md-6 text-end p-2">
                  <ReactToPrint
                    trigger={() => (
                      <Button
                        variant="contained"
                        size="small"
                        id="printBtn"
                        style={{
                          background: "#0577ab",
                          color: "#fff",
                          padding: "7px",
                          width: "100px",
                        }}
                        startIcon={<PrintRoundedIcon />}
                      >
                        print
                      </Button>
                    )}
                    content={() => this.componentRef}
                  />
                </div>
              </div>
              <div style={{ maxWidth: "100%" }}>
                <MaterialTable
                  title="'Holding Period Over' Asset Cycle List"
                  tableRef={(el) => (this.componentRef = el)}
                  icons={UiUtils.getMaterialTableIcons()}
                  localization={{
                    body: {
                      emptyDataSourceMessage: "Please add customer",
                    },
                  }}
                  columns={[
                    {
                      title: "#",
                      render: (rowData) => rowData.tableData.id + 1,
                      width: "5%",
                      align: "left",
                      cellStyle: {
                        width: "6%",
                      },
                    },
                    {
                      title: "Asset Name",
                      field: "assetname",
                      cellStyle: {
                        width: "20%",
                      },
                    },
                    {
                      title: "Asset UID",
                      field: "assetuid",
                      cellStyle: {
                        width: "20%",
                      },
                    },
                    {
                      title: "Asset Code",
                      field: "assetcode",
                      cellStyle: {
                        width: "20%",
                      },
                    },
                    {
                      title: "Asset Type",
                      field: "assetType",
                      cellStyle: {
                        width: "20%",
                      },
                    },
                    {
                      title: "Status",
                      field: "status",
                    },
                  ]}
                  data={this.state.holdingPeriodOverCycleList}
                  options={{
                    sorting: true,
                    search: false,
                    actionsColumnIndex: -1,
                    initialPage: this.state.initialPage,
                    pageSize: this.state.pageSize,
                    pageSizeOptions: Utils.materialTablePageSize(),
                    paging: this.state.isPaging,
                    headerStyle: {
                      backgroundColor: "#0B6F9D",
                      fontWeight: "bold",
                      color: "#ffff",
                      align: "left",
                    },
                  }}
                />
              </div>
            </>
          ) : (
            <div className="row">
              <div className="col-md-6 text-start p-2">
                <BackIconButton onClick={this.backButton.bind(this)} />
              </div>
              <div className="col-md-12">
                <Card>
                  <CardBody>
                    <div className="row">
                      <div className="col-md-12" style={{ padding: "2em" }}>
                        <h5>
                          <b>'Holding Period Over' Cycle List Not Found</b>
                        </h5>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </div>
          )}
        </>
      );
    }
  }
}
export default withRouter(HoldingPeriodOverCycleList);
